var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.entity)?_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.click",value:(_vm.entity.description),expression:"entity.description",modifiers:{"click":true}}],staticClass:"linkButton sourceTooltip"},[_vm._v(_vm._s(_vm.entity.name))]):_c('span',{staticClass:"sourceLink"},[_vm._v(_vm._s(_vm.source))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b1189c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceTooltip.vue
// module id = null
// module chunks = 